/* eslint-disable jsx-a11y/anchor-is-valid */
import {SnackbarProvider} from 'notistack'
import {Dispatch, FC, SetStateAction, useEffect, useMemo, useState} from 'react'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCell,
} from '../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../hooks/useHoteleria'
import {useKhipu} from '../../../../../hooks/useKhipu'
import {useCentralServices} from '../../../hooks/useCentralServices'
import {BedModel} from '../../bed/model'
import {getBedsService} from '../../bed/services'
import {SelectOption} from '../../../../../models/utility.model'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {ModalUpdateStatus} from './modals/ModalUpdateStatus'
import {TabModel} from '../../../../../models'
import {useModules} from '../../../hooks/useModules'

const TableBeds = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    updateTable,
    setUpdateTable,
    clearTable,
    setClearTable,
    selectedOn,
    selected,
    clearSelected,
  } = useKTable()

  const {changeCurrentTabItem, currentTabItem} = useHoteleria()
  const {changeSearchValues, searchValues, clearSearchValues} = useKhipu()
  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSites] = useState<SelectOption[]>([])
  const [camp, setCamps] = useState<SelectOption[]>([])
  const [roomType, setRoomType] = useState<SelectOption[]>([])
  const [modules, setModules] = useState<SelectOption[]>([])

  const [statusBed, setStatusBed] = useState<SelectOption[]>([])
  const [subStatusBed, setSubStatusBed] = useState<SelectOption[]>([])
  const camaCaliente = [
    {value: true, label: 'SI'},
    {value: false, label: 'NO'},
  ]
  const [showModalUpdate, setShowModalUpdate] = useState<boolean>(false)

  const [level, setLevel] = useState<SelectOption[]>([])
  const {getModules} = useModules()

  const {getCompanies, getClients, getSites, getCamps, getMasterTable} = useCentralServices()

  const getBeds = async () => {
    try {
      setLoading(true)
      const {data: response} = await getBedsService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        isControlEstados: true,
        ...searchValues,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
          perPage: 2000,
        })
        let obj: TabModel = {
          ...currentTabItem,
          loadingTable: false,
          updateFromOther: false,
        }
        changeCurrentTabItem(obj)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    setCompany(data)
  }

  const getClientsFn = async () => {
    const data = await getClients({isCombo: true}, 1)
    setClient(data)
  }

  const getSitesFn = async () => {
    const data = await getSites({isCombo: true}, 1)
    setSites(data)
  }

  const getCampsFn = async () => {
    const data = await getCamps({isCombo: true}, 1)
    setCamps(data)
  }

  const getModulesFn = async () => {
    const data = await getModules({})
    setModules(data)
  }

  const getRoomsTypeFn = async () => {
    const data = await getMasterTable('TipoHabitacion', true)
    setRoomType(data)
  }

  const getLevelFn = async () => {
    const data = await getMasterTable('Nivel', true)
    setLevel(data)
  }

  const getStatusBedFn = async () => {
    const data = await getMasterTable('EstadoCama', true)
    const filterData = data.filter((item) => item.codigo === '1' || item.codigo === '3')
    setStatusBed(filterData)
  }

  const getSubStatusBedFn = async (statusPadre: string) => {
    const data = await getMasterTable('SubEstadoCama', true)
    const filteredData = data?.filter((item) => item.codigoPadre === statusPadre)
    const mappedMaster = filteredData?.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
    }))
    setSubStatusBed(mappedMaster)
  }

  const handleFilterSubStatus = (e: any, name: string) => {
    let code = e.codigo
    let value = e.value
    getSubStatusBedFn(code)
    const {SubEstadoCamaId, ...valuesSearch} = searchValues
    const nuevoObjeto = {...valuesSearch, [name]: value}
    changeSearchValues(nuevoObjeto)
  }

  useEffect(() => {
    setPagination({...pagination, perPage: 2000})
  }, [])

  useEffect(() => {
    if (pagination.perPage === 2000) {
      getBeds()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, pagination.perPage])

  useEffect(() => {
    if (currentTabItem.loadingTable && currentTabItem.updateFromOther) {
      clearSelected()
      getBeds()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.loadingTable, currentTabItem.updateFromOther])

  useEffect(() => {
    if (updateTable) {
      clearSelected()
      if (pagination.currentPage === 1) {
        getBeds()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 2000,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }
  }, [updateTable])

  useEffect(() => {
    if (clearTable) {
      clearSelected()
      if (pagination.currentPage === 1) {
        getBeds()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 2000,
          totalResults: 0,
        })
      }

      setClearTable(false)
    }
  }, [clearTable])

  const columns: Column<BedModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelect={true} />,
        id: 'selection',
        Cell: ({...props}) => <KTableSelectionCell id={props.data[props.row.index].Id} />,
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name='CompaniaId'
            selecteable
            data={compani}
          />
        ),
        accessor: 'Compania_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name='ClienteId'
            selecteable
            data={client}
            // onGetValueSelect={handleFilterSite}
          />
        ),
        accessor: 'Cliente_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Site'
            name='SiteId'
            selecteable
            data={site}
            // onGetValueSelect={handleFilterCamp}
          />
        ),
        accessor: 'Site_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name='CampamentoId'
            selecteable
            data={camp}
            // onGetValueSelect={handleFilterModule}
          />
        ),
        accessor: 'Campamento_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Módulo'
            name='ModuloId'
            selecteable
            data={modules}
          />
        ),
        accessor: 'Modulo_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Habitación'
            name='HabitacionCodigo'
            searcheable
          />
        ),
        accessor: 'Habitacion_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Habitación'
            name='TipoHabitacionId'
            selecteable
            data={roomType}
          />
        ),
        accessor: 'TipoHabitacion_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nomenclatura de Cama' name='Codigo' searcheable />
        ),
        accessor: 'Codigo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cama Caliente'
            name='CamaCaliente'
            selecteable
            data={camaCaliente}
          />
        ),
        accessor: 'CamaCaliente',
        Cell: ({...props}) => <div>{props.row.original.CamaCaliente ? 'SI' : 'NO'}</div>,
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Piso'
            name='HabitacionNivelId'
            selecteable
            data={level}
          />
        ),
        accessor: 'Nivel_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado'
            name='EstadoCamaId'
            selecteable
            data={statusBed}
            onGetValueSelect={handleFilterSubStatus}
          />
        ),
        accessor: 'EstadoCama_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Sub Estado'
            name='SubEstadoCamaId'
            selecteable
            data={subStatusBed}
          />
        ),
        accessor: 'SubEstadoCama_descripcion',
      },
    ],
    [compani, client, site, camp, roomType, level, statusBed, subStatusBed, selectedOn, data],
  )

  useEffect(() => {
    getCompaniesFn()
    getLevelFn()
    getRoomsTypeFn()
    getStatusBedFn()
    getClientsFn()
    getSitesFn()
    getCampsFn()
    getModulesFn()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleUpdateData = () => {
    setShowModalUpdate(true)
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <div className='d-flex justify-content-end p-2 me-5'>
          <button
            type='button'
            className='btn btn-success me-3'
            onClick={handleUpdateData}
            disabled={selected.length < 1}
          >
            Actualizar
          </button>
        </div>
        <KTable data={data} columns={columns} />
        {showModalUpdate ? (
          <ModalUpdateStatus
            dataUpdate={selected}
            setShow={setShowModalUpdate}
            show={showModalUpdate}
          />
        ) : (
          <></>
        )}
      </KTCard>
    </>
  )
}

const TableBedsWrapper = () => {
  return (
    <KTableProvider>
      <TableBeds />
    </KTableProvider>
  )
}

const ControlStatus = () => {
  const {isAllowed} = useHoteleria()
  return (
    <div className=''>
      {isAllowed('LISTAR') && (
        <>
          <TableBedsWrapper />
        </>
      )}
      <SnackbarProvider />
    </div>
  )
}

export {ControlStatus}
